const defaultState = {
  user: {},
  error: null,
  fetching: false,
  fetched: false
};

const changePasswordReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CHANGE_PASSWORD_FETCH_PENDING': {
      return {
        ...state, fetching: true
      };
    }
    case 'CHANGE_PASSWORD_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, user: action.payload
      };
    }
    case 'CHANGE_PASSWORD_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default changePasswordReducer;


// WEBPACK FOOTER //
// ./src/reducers/changePassword.js